// frontend/src/features/workflows/services/workflowService.js

import apiClient from '../../../api/apiClient';

/**
 * Experimental setups CRUD
 */
export const fetchExperimentalSetups = params =>
  apiClient.get('/api/workflows/setups/', { params }).then(r => r.data);
export const createExperimentalSetup = (data, source = 'unknown') =>
  apiClient
    .post('/api/workflows/setups/', data, {
      headers: { 'X-Client-Source': source || 'unknown' },
    })
    .then(r => r.data);

/**
 * Fetch all WorkflowRun records.
 */
export function fetchRuns() {
  return apiClient.get('/api/workflows/runs/').then(res => res.data);
}

/**
 * Fetch the current durable state of an ExecutionRequest.
 */
export function fetchExecutionRequestStatus(executionRequestId) {
  return apiClient
    .get(`/api/workflows/execution-requests/${executionRequestId}/`)
    .then(res => res.data);
}
